<template>
  <div style="overflow: auto;width: 800px;padding:40px 0 0 40px;">
    <el-form :model="order" label-width="90px" size="small" v-loading="loading">
      <el-form-item label="商品名称">{{ order.title }}({{ order.goods_type }})</el-form-item>
      <el-form-item label="订单号">{{ order.uuid }}</el-form-item>
      <el-form-item label="订单金额">{{ order.total }}</el-form-item>
      <el-form-item label="支付状态">{{ order.pay_status_name }}</el-form-item>
      <el-form-item label="出票状态">{{ order.check_status_name }}</el-form-item>
      <el-form-item v-if="order.intention_refund_info && order.intention_refund_info.submit_at" label="退款申请">
        <div class="intention-refund-detail">
          <div>提交时间：{{ order.intention_refund_info.submit_at }}</div>
          <div>原因：{{ order.intention_refund_info.reason || '-' }}</div>
          <div>备注：{{ order.intention_refund_info.remark || '-' }}</div>
          <el-button type="warning" size="mini" style="margin-top:8px" @click="confirmCancelIntentionRefund">取消退款申请</el-button>
        </div>
      </el-form-item>
      <el-form-item label="下单时间">{{ order.created_at }}</el-form-item>
      <el-form-item label="出行时间">
        <el-date-picker v-model="order.use_date" type="date" style="width: 70%" value-format="yyyy-MM-dd"
                        placeholder="选择日期"/>
      </el-form-item>
      <el-form-item label="联系人">
        <el-input v-model="order.linker_name" style="width: 70%"></el-input>
      </el-form-item>
      <el-form-item label="联系人手机">
        <el-input v-model="order.linker_mobile" style="width: 61%"></el-input>
        <el-button type="primary" :disabled="order.check_status !=1" title="出票后可发送">再次短信通知
        </el-button>
      </el-form-item>
      <el-form-item label="游客列表" v-if="order.people">
        <el-table :data="order.people" :border="true" style="width: 70%">
          <el-table-column label="姓名" prop="name"></el-table-column>
          <el-table-column label="证件类型" prop="cert_type"></el-table-column>
          <el-table-column label="证件号码" prop="cert_no"></el-table-column>
        </el-table>
      </el-form-item>
      <el-form-item label="票付通信息" v-if="order.pft">
        订单号:{{ order.pft.pft_order_no }}
        验票码:{{ order.pft.code || '无验票码' }}
        订单状态:{{ order.pft.pft_status_name }}<br>
        <span v-if="order.pft.pft_error">
                错误原因:{{ order.pft.pft_error }}
              </span>
      </el-form-item>
      <el-form-item label="航班信息" v-if="order.ship">
        <el-row>
          <el-col :span="19">
            <el-alert title="重新选择航班后，需要保存后才会生效" style="padding:0 5px;margin-bottom: 10px;" :closable="false"
                      type="warning"></el-alert>
            {{ order.ship.sailings_code }} {{ order.ship.start_wharf }}({{ order.ship.start_time }})
            ~ {{ order.ship.end_wharf }}({{ order.ship.end_time }})
            <el-button type="primary" size="mini" @click="getSailingsList">重新选择</el-button>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="7">
            <el-input v-model="order.ship.enter_no" placeholder="登船口"></el-input>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item style="border-top:1px solid #eee;padding: 10px 0;">
        <el-button type="primary" @click="doEdit" :loading="postLoading">保存修改</el-button>
      </el-form-item>
    </el-form>

    <el-dialog
      title="选择航班"
      :visible.sync="sailingsDialog"
      :append-to-body="true"
      width="50%"
    >
      <el-table
        :data="sailingsList"
        style="width: 100%"
      >
        <el-table-column
          label="航班名称"
          prop="sailings_title"
        >
        </el-table-column>
        <el-table-column
          prop="sailings_code"
          label="航班号"
        >
        </el-table-column>
        <el-table-column
          prop="address"
          label="时间信息"
        >
          <div slot-scope="scope">
            {{ scope.row.start_time }} - {{ scope.row.end_time }}
          </div>
        </el-table-column>
        <el-table-column
          prop="address"
          label="码头信息"
          width="220"
        >
          <div slot-scope="scope">
            {{ scope.row.start_wharf }} - {{ scope.row.end_wharf }}
          </div>
        </el-table-column>
        <el-table-column
          label="销售状态"
          width="80"
        >
          <template slot-scope="scope">
            <el-tag size="mini" type="success" v-if="scope.row.on_sale === 1">销售中</el-tag>
            <el-tag size="mini" type="danger" v-else>已下架</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="120"
        >
          <div slot-scope="scope">
            <el-button type="primary" size="mini" :disabled="!scope.row.sale_status"
                       @click="doChoose(scope.row)">选择
            </el-button>
          </div>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="sailingsDialog = false">取 消</el-button>
        <el-button type="primary" @click="doChoose">确
          定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "order-detail",
  props: {
    uuid: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      order: {},
      loading: false,
      postLoading: false,
      sailingsDialog: false,
      sailingsLoading: false,
      sailingsList: []
    }
  },
  methods: {
    getDetails: function () {
      this.loading = true;
      this.$http.request('orderDetails', {uuid: this.uuid}).then(res => {
        if (res.status === 'success') {
          this.order = res.data;
          this.loading = false;
        }
      });
    },
    getSailingsList: function () {
      this.sailingsDialog = true;
      this.sailingsList = [];
      this.$http.request('bindSingsList', {ship_id: this.order.product_id}).then((res) => {
        this.sailingsList = res.data.sailings;
      });
    },
    doChoose: function (sailing) {
      this.order.ship = sailing;
      this.sailingsDialog = false;
    },
    confirmCancelIntentionRefund: function () {
      const _self = this;
      this.$confirm('确认取消该订单的退款申请？取消后订单将恢复为正常状态。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _self.$http.request('cancelIntentionRefund', {uuid: _self.order.uuid}).then(res => {
          if (res.status === 'success') {
            _self.$message({message: res.message, type: 'success'});
            _self.getDetails();
          }
        });
      }).catch(() => {});
    },
    doEdit: function () {
      let _self = this;
      this.postLoading = true;
      this.$http.request('editOrder', this.order).then(res => {
        this.postLoading = false;
        if (res.status === 'success') {
          this.$message({
            message: res.message,
            type: 'success',
            onClose: function () {
              _self.postLoading = false;
              _self.getDetails();
            }
          });
        }
      });
    }
  },
  created: function () {
    this.getDetails();
  },
  watch: {
    uuid: function () {
      this.getDetails();
    }
  }
}
</script>

<style scoped>
.intention-refund-detail {
  font-size: 13px;
  line-height: 1.6;
  color: #606266;
}
</style>



// WEBPACK FOOTER //
// src/pages/order/order-detail-left.vue